<template>
  <div class="privacy-policy_page">
    <div class="language-container">
      <el-select v-model="language" :popper-append-to-body="false" placeholder="请选择语言" popper-class="language-popper">
        <el-option v-for="item in languageOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </div>

    <!-- 中文 -->
    <div v-show="language === 'zh-CN'" class="content-container">
      <h1>伽勒智能电表云监控系统应用程序和网站的隐私政策</h1>
      <label> 本隐私政策解释了 伽勒智能电表云监控系统APP是 苏州伽勒信息科技有限公司 自主开发,<br>（“我们”或“我们的”）如何收集、使用、披露和<br>
      </label>
      <label>保护我们移动应用程序和网站（“服务”）用户的个人信息。<br>
        <br></label>
      <label>使用我们的服务即表示您同意本隐私政策中所述的做法。如果你不
        <br></label>
      <label>同意本隐私政策，请不要使用本服务。 <br></label>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="">我们收集的信息<br></h2>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <h3 style="position:relative;left:5%">1.&nbsp;个人信息:</h3>
        <label style="position:relative;left:10%">
          • &nbsp;当您注册帐户或使用我们的服务时，我们可能会收集个人信息<br>
          您的姓名、电子邮件地址、联系电话和其他信息 <br>
          相关细节。<br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h3 style="position:relative;left:5%">2.&nbsp;使用数据：</h3>
        <label style="position:relative;left:10%">
          • &nbsp;我们可能会收集您与服务互动的信息，包括 <br>
          访问的页面、使用的功能和其他使用统计数据。 <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="">我们如何使用您的信息 <br></h2>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <label>我们可能会将收集的信息用于以下目的:<br> </label>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <label style="position:relative;left:10%">1.&nbsp;提供和维护服务<br></label>
        <label style="position:relative;left:10%">2.&nbsp;与您沟通，包括回复<br></label>
        <label style="position:relative;left:10%">回复您的询问并提供更新。<br></label>
        <label style="position:relative;left:10%">3.&nbsp;遵守法律义务，保护我们的权利。<br></label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="">数据共享和披露 <br></h2>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <label>我们可能会与以下人员共享您的信息：<br></label>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <h3 style="position:relative;left:5%">1.&nbsp;服务提供商：</h3>
        <label style="position:relative;left:10%">
          • &nbsp;我们聘请的第三方公司或个人为我们的服务提供便利， <br>
          包括数据存储、分析和客户支持。 <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h3 style="position:relative;left:5%">2.&nbsp;法律合规：</h3>
        <label style="position:relative;left:10%">
          • &nbsp;当法律要求或响应有效的法律程序时，我们可能会披露 <br>
          您的信息。<br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">安全</h2>
        <label style="position:relative;">
          我们采用行业标准的安全措施来保护您的个人信息。然而，<br>
          没有一种通过互联网或电子存储的传输方式是完全安全的，我们 <br>
          不能保证绝对安全。 <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">您的选择</h2>
        <label style="position:relative;">
          您可以选择不提供某些信息，但这可能会限制您使用某些信息的能力 <br>
          服务的特点。<br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">儿童隐私</h2>
        <label style="position:relative;">
          我们的服务不针对13岁以下的个人。我们不会故意收集 <br>
          儿童的个人信息。如果我们得知我们收集了个人信息 <br>
          对于13岁以下的儿童，我们将采取措施删除此类信息。 <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">本隐私政策的变更</h2>
        <label style="position:relative;">
          我们可能会不时更新本隐私政策。最新版本将发布在 <br>
          你的网站。您在任何更改后继续使用本服务，即表示您接受 <br>
          更新的隐私政策。 <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">联系我们</h2>
        <label style="position:relative;">
          如果您对本隐私政策有任何疑问或疑虑，请通过以下方式与我们联系： <br>
          hannian.li@jialeinfo.com <br>
        </label>
      </div>
    </div>

    <!-- 英文 -->
    <div v-show="language === 'en-US'" class="content-container">
      <h1>Privacy Policy for BlueSpide App and Website</h1>
      <label> This privacy policy explains how BlueSpide APP is independently developed <br> by Suzhou Jiale Information Technology Co., Ltd.
        ("we," "us," or "our") collects, uses, discloses, and
      </label><br>
      <label>safeguards the personal information of users of our mobile application and website ("Service").<br>
        <br></label>
      <label>By using our Service, you consent to the practices described in this Privacy Policy. If you do not
        <br></label>
      <label>agree to this Privacy Policy, please do not use the Service. <br></label>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="">Information We Collect <br></h2>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <h3 style="position:relative;left:5%">1.&nbsp;Personal Information:</h3>
        <label style="position:relative;left:10%">
          • &nbsp;When you register for an account or use our Service, we may collect personal<br>
          information such as your name, email address, contact number, and other <br>
          relevant details.<br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h3 style="position:relative;left:5%">2.&nbsp;Usage Data:</h3>
        <label style="position:relative;left:10%">
          • &nbsp;We may collect information about your interactions with the Service, including <br>
          pages visited, features used, and other usage statistics. <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="">How We Use Your Information <br></h2>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <label>We may use the information we collect for the following purposes:<br> </label>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <label style="position:relative;left:10%">1.&nbsp;To provide and maintain the Service.<br></label>
        <label style="position:relative;left:10%">2.&nbsp;To communicate with you, including responding<br></label>
        <label style="position:relative;left:10%">to your inquiries and providing updates.<br></label>
        <label style="position:relative;left:10%">3.&nbsp;To comply with legal obligations and protect our
          rights.<br></label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="">Data Sharing and Disclosure <br></h2>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <label>We may share your information with:<br></label>
      </div>
      <div style="text-align:left;position:relative;left:11%">
        <h3 style="position:relative;left:5%">1.&nbsp;Service Providers:</h3>
        <label style="position:relative;left:10%">
          • &nbsp;Third-party companies or individuals we engage to facilitate our Service, <br>
          including data storage, analysis, and customer support. <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h3 style="position:relative;left:5%">2.&nbsp;Legal Compliance:</h3>
        <label style="position:relative;left:10%">
          • &nbsp;When required by law or in response to valid legal process, we may disclose <br>
          your information.<br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">Security</h2>
        <label style="position:relative;">
          We employ industry-standard security measures to protect your personal information. However, <br>
          no method of transmission over the internet or electronic storage is completely secure, and we <br>
          cannot guarantee absolute security. <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">Your Choices</h2>
        <label style="position:relative;">
          You can choose not to provide certain information, but this may limit your ability to use certain <br>
          features of the Service.<br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">Children's Privacy</h2>
        <label style="position:relative;">
          Our Service is not directed at individuals under the age of 13. We do not knowingly collect <br>
          personal information from children. If we learn that we have collected personal information <br>
          from a child under 13, we will take steps to delete such information. <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">Changes to this Privacy Policy</h2>
        <label style="position:relative;">
          We may update this Privacy Policy from time to time. The most current version will be posted on <br>
          ur website. Your continued use of the Service after any changes indicates your acceptance of <br>
          the updated Privacy Policy. <br>
        </label>
      </div>

      <div style="text-align:left;position:relative;left:11%">
        <h2 style="position:relative;">Contact Us</h2>
        <label style="position:relative;">
          If you have any questions or concerns about this Privacy Policy, please contact us at <br>
          hannian.li@jialeinfo.com <br>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data () {
    return {
      languageOptions: [
        {
          value: 'zh-CN',
          label: '中文'
        },
        {
          value: 'en-US',
          label: '英文'
        }
      ],
      language: 'zh-CN'
    }
  }
}
</script>

<style scoped lang="stylus">

  .privacy-policy_page {
    height: 100vh;
    width: 100vw;
    padding: 8px;
    margin: 0;
    box-sizing: border-box;
    background-color: #EEEEEE;
    position: relative;
    overflow-y: auto;

    .language-container {
      position: fixed;
      width: 200px;
      height: 40px;
      top: 10px;
      right: 30px;
      background-color: transparent;
    }

    .content-container {
      position: absolute;
      height: fit-content;
      width: 50%;
      text-align: center;
      background-color: #fff;
      border-radius: 5px;
      padding: 1% 0 10%;
      filter: drop-shadow(2px 4px 6px black);
      left: 0;
      right: 0;
      margin: auto;
    }
  }

</style>

<style>

  h1,
  h2,
  h3 {
    font-size: revert !important;
    padding: revert !important;
    margin: revert !important;
    color: black !important;
  }

  label {
    line-height: 2;
  }

  body {
    font-size: revert !important;
    color: black !important;
    font-family: inherit !important;
  }

  .el-select-dropdown__item,
  .el-select-dropdown__list {
    background-color: inherit !important;
    color: rgb(0, 0, 0) !important;
  }

  .el-select-dropdown__item {
    border-bottom:none;
  }

  .el-popper[x-placement^=bottom] .popper__arrow::after{
    border-bottom-color: #ffffff !important;
  }

  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #F5F7FA !important;
  }
</style>
